export default {
  needHelp: {
    title: 'Need some help?',
    contactUs: {
      title: 'Contact us',
      label: 'Online for Business',
      contactNo: '0345 072 5555',
      dot: '.',
      contactInfo: `We're open Mon-Fri 7am-8pm, Sat 9am-2pm. If you're outside the UK call +44 1733 347 338.`,
      callUsUsing: `You can call us using Relay UK if you have a hearing or speech impairment. There's more information on the`,
      callUsLabel: 'Relay UK help pages',
      callUsHelpLink: 'https://www.relayuk.bt.com',
      signVideoLabel: 'Sign Video services',
      signVideoLink: 'https://www.lloydsbank.com/contact-us/sign-video.html',
      signVideoInfo:
        'are also available if you’re Deaf and use British Sign Language.',
    },
    amIFullSignatory: {
      title: 'How do I know if I’m a Full Signatory?',
      content_1:
        'Full signatories are named on the bank mandate – the set of instructions given to us when the business account was opened.',
      content_2:
        'Only full signatories can apply for loans and overdrafts and open and close accounts in a branch, by post or phone.',
      content_3: 'Still not sure? Please contact us for some help.',
    },
    bankMandateInstruction: {
      title: 'What is a bank mandate and signing instructions?',
      content_1:
        'A bank mandate is the set of instructions given to us when the business account is opened.',
      list: {
        header: 'It includes:',
        listItems: [
          {
            label: 'Signatories',
            content:
              'The names and signatures of the people with access to the business account, products and services.',
          },
          {
            label: 'Business signing instructions',
            content:
              'How many signatories are needed to authorise payments and other tasks in branch, by post or phone.',
          },
        ],
      },
    },
    findBankMandate: {
      title: 'How can I find out what’s on the bank mandate?',
      content_1:
        'If you can’t find your bank mandate, please contact us for some help.',
    },
    fullAccessUser: {
      title: 'What can a Full Access User do?',
      list: {
        header: 'Full Access Users can: ',
        listItems: [
          {
            id: 'list-item-1',
            content: 'make and approve online payments',
          },
          {
            id: 'list-item-2',
            content: 'give other people access to Online for Business',
          },
          {
            id: 'list-item-3',
            content: 'set up online payment controls',
          },
          {
            id: 'list-item-4',
            content:
              'change the business details, for example update the address',
          },
          {
            id: 'list-item-5',
            content:
              'apply for products and services, including loans and overdrafts.',
          },
        ],
      },
    },
    smsMobileNoIncorrect: {
      title: 'My mobile number isn’t correct. How do I fix it?',
      content_1: 'To make sure we have the right phone number for you, simply',
      content_2: 'fill in, print, and send us this form',
      supportLink: 'https://www.lloydsbank.com/business/help-and-support/account-management/update-phone-number.html'
    },
  },
  title: 'Register for Online for Business',
  href: 'https://www.lloydsbank.com/etc/designs/lloyds/favicon.ico',
};
